// export default AttendancesReportData;
// import { useContext, useEffect, useState } from "react";
// import Select from "react-select";
// import toast from "react-hot-toast";
// import { MdSearch } from "react-icons/md";
// import { BallTriangle } from "react-loader-spinner";
// import Card from "components/card";
// import Checkbox from "components/checkbox";
// import ConfirmationModal from "pages/Common/ConfirmationModal";
// import Nodatafound from "pages/Common/Nodatafound";
// import { AuthContext } from "contexts/AuthContext";
// import attendanceService from "ApiService/Teacher/Attendance";

// const AttendancesReportData = ({ selectedClass }) => {
//   const { state } = useContext(AuthContext);
//   const [date, setDate] = useState("");
//   const [attendanceList, setAttendanceList] = useState([]);
//   const [filteredList, setFilteredList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showEditSheet, setShowEditSheet] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Available dates dropdown
//   const [availableDates, setAvailableDates] = useState([]);

//   // Helper to get string ID (in case it's an object)
//   const getIdString = (id) => {
//     if (typeof id === "string") return id;
//     if (typeof id === "object" && id?._id) return id._id;
//     return "";
//   };

//   // Fetch available attendance dates for dropdown
//   const fetchMarkedDates = async () => {
//     try {
//       const courseId = getIdString(selectedClass.courseId);
//       const batchId = getIdString(selectedClass.batchId);

//       const res = await attendanceService.getMarkedAttendanceDates(courseId, batchId);
//       if (res.data.success && res.data.dates?.length) {
//         setAvailableDates(res.data.dates);
//       } else {
//         setAvailableDates([]);
//         toast.error("No marked attendance dates found.");
//       }
//     } catch (err) {
//       setAvailableDates([]);
//       toast.error("Error fetching marked dates.");
//     }
//   };

//   // Fetch complete attendance (present + absent) for selected date
//   const fetchCompleteAttendance = async (selectedDate) => {
//     if (!selectedDate) return;
//     try {
//       setLoading(true);

//       const courseId = getIdString(selectedClass.courseId);
//       const batchId = getIdString(selectedClass.batchId);

//       const res = await attendanceService.getCompleteAttendanceForDate(
//         courseId,
//         batchId,
//         selectedDate
//       );
//       console.log("Fetched attendance data:", res.data);

//       if (res.data.success) {
//         setAttendanceList(res.data.data);
//         setFilteredList(res.data.data);
//       } else {
//         setAttendanceList([]);
//         setFilteredList([]);
//         toast.error("No attendance data found for selected date.");
//       }
//     } catch (error) {
//       setAttendanceList([]);
//       setFilteredList([]);
//       toast.error("Error fetching attendance data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle date change from dropdown
//   const handleDateChange = (selected) => {
//     if (!selected) return;
//     setDate(selected.value);
//     setShowEditSheet(false);
//     setSearchTerm("");
//     fetchCompleteAttendance(selected.value);
//   };

//   // Toggle attendance status for edit mode
//   const handleCheckboxChange = (studentId) => {
//     setAttendanceList((prev) =>
//       prev.map((student) =>
//         student._id === studentId
//           ? {
//               ...student,
//               status: student.status === "Present" ? "Absent" : "Present",
//             }
//           : student
//       )
//     );
//     setFilteredList((prev) =>
//       prev.map((student) =>
//         student._id === studentId
//           ? {
//               ...student,
//               status: student.status === "Present" ? "Absent" : "Present",
//             }
//           : student
//       )
//     );
//   };

//   // Save updated attendance back to backend
//   const saveAttendanceChanges = async () => {
//     try {
//       const courseId = getIdString(selectedClass.courseId);
//       const batchId = getIdString(selectedClass.batchId);

//       const absentStudents = attendanceList
//         .filter((student) => student.status === "Absent")
//         .map((student) => student._id);

//       const payload = {
//         courseId,
//         batchId,
//         date,
//         absentStudents,
//       };

//       const res = await attendanceService.updateAttendance(payload);
//       if (res.data.success) {
//         toast.success("Attendance updated successfully.");
//         setShowEditSheet(false);
//         fetchCompleteAttendance(date);
//       } else {
//         toast.error("Failed to update attendance.");
//       }
//     } catch (error) {
//       toast.error("Error updating attendance.");
//     }
//   };

//   const handleSubmit = async () => {
//     await saveAttendanceChanges();
//     setIsModalOpen(false);
//   };

//   // Search/filter students
//   useEffect(() => {
//     if (!searchTerm) {
//       setFilteredList(attendanceList);
//     } else {
//       const filtered = attendanceList.filter((student) =>
//         student.name.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredList(filtered);
//     }
//   }, [searchTerm, attendanceList]);

//   // Fetch available dates when selectedClass changes
//   useEffect(() => {
//     if (selectedClass) {
//       fetchMarkedDates();
//       setDate("");
//       setAttendanceList([]);
//       setFilteredList([]);
//       setShowEditSheet(false);
//       setSearchTerm("");
//     }
//   }, [selectedClass]);

//   return (
//     <Card extra={"w-full sm:overflow-auto p-4"}>
//       <header className="relative mt-10 flex items-center justify-between">
//         <div className="text-xl font-bold text-navy-700 dark:text-white">
//           Attendance Report
//         </div>
//         {!showEditSheet && date && (
//           <button
//             onClick={() => setShowEditSheet(true)}
//             className="h-10 w-40 rounded-xl bg-brand-500 text-lg text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
//           >
//             Edit Attendance
//           </button>
//         )}
//       </header>

//       <div className="mb-4 flex flex-col gap-4 md:flex-row md:items-end">
//         <div className="w-60">
//           <label className="mb-2 block text-sm font-bold text-gray-700 dark:text-white">
//             Select Date:
//           </label>
//           <Select
//             value={date ? { value: date, label: date } : null}
//             onChange={handleDateChange}
//             options={availableDates.map((d) => ({ value: d, label: d }))}
//             placeholder="Search or select date..."
//             isSearchable={true}
//             styles={{
//               control: (provided) => ({
//                 ...provided,
//                 backgroundColor: "var(--tw-bg-opacity)",
//               }),
//               menu: (provided) => ({
//                 ...provided,
//                 zIndex: 9999,
//               }),
//             }}
//           />
//         </div>

//         <div className="w-full md:w-64">
//           <div className="relative">
//             <input
//               type="text"
//               placeholder="Search by name..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full rounded-lg border border-gray-300 px-3 py-2 pl-10 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 dark:border-navy-600 dark:bg-navy-700 dark:text-white"
//             />
//             <MdSearch className="absolute left-3 top-2.5 h-5 w-5 text-gray-500 dark:text-gray-400" />
//           </div>
//         </div>
//       </div>

//       {loading ? (
//         <div className="flex h-64 items-center justify-center">
//           <BallTriangle color="#5431ed" />
//         </div>
//       ) : showEditSheet ? (
//         <div className="overflow-x-scroll xl:overflow-x-hidden">
//           {filteredList.length ? (
//             <>
//               <table className="w-full">
//                 <thead>
//                   <tr className="border-b border-gray-200 dark:border-white/10">
//                     <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
//                       SR.NO
//                     </th>
//                     <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
//                       Attendance Mark
//                     </th>
//                     <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
//                       Name
//                     </th>
//                     <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
//                       Status
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredList.map((student, idx) => (
//                     <tr
//                       key={student._id}
//                       className="border-b border-gray-200 dark:border-white/10"
//                     >
//                       <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
//                         {idx + 1}
//                       </td>
//                       <td className="px-[27px] py-[16px] text-center">
//                         <Checkbox
//                           onChange={() => handleCheckboxChange(student._id)}
//                           checked={student.status === "Present"}
//                         />
//                       </td>
//                       <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
//                         {student.name}
//                       </td>
//                       <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
//                         {student.status}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>

//               <div className="flex justify-end mt-4 gap-4">
//                 <button
//                   onClick={() => {
//                     setShowEditSheet(false);
//                     fetchCompleteAttendance(date);
//                   }}
//                   className="rounded-xl bg-red-500 px-4 py-2 text-white hover:bg-red-600"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={() => setIsModalOpen(true)}
//                   className="rounded-xl bg-green-500 px-4 py-2 text-white hover:bg-green-600"
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </>
//           ) : (
//             <Nodatafound title="No attendance data found." />
//           )}
//         </div>
//       ) : filteredList.length ? (
//         <div className="overflow-x-scroll xl:overflow-x-hidden">
//           <table className="w-full">
//             <thead>
//               <tr className="border-b border-gray-200 dark:border-white/10">
//                 <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
//                   SR.NO
//                 </th>
//                 <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
//                   Name
//                 </th>
//                 <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
//                   Contact
//                 </th>
//                 <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
//                   Status
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredList.map((student, idx) => (
//                 <tr
//                   key={student._id}
//                   className="border-b border-gray-200 dark:border-white/10"
//                 >
//                   <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
//                     {idx + 1}
//                   </td>
//                   <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
//                     {student.name}
//                   </td>
//                   <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
//                     {student.contactNumber}
//                   </td>
//                   <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
//                     {student.status}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <Nodatafound
//           title={
//             searchTerm
//               ? `No students found matching "${searchTerm}".`
//               : "No attendance data available."
//           }
//         />
//       )}

//       <ConfirmationModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         onConfirm={handleSubmit}
//         title="Confirm Attendance Submission"
//         message="Are you sure you want to submit the attendance for this class?"
//         confirmText="Yes, Submit Attendance"
//         cancelText="Cancel"
//         icon="info"
//       />
//     </Card>
//   );
// };

// export default AttendancesReportData

import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { MdSearch } from 'react-icons/md';
import { BallTriangle } from 'react-loader-spinner';
import Card from 'components/card';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import Nodatafound from 'pages/Common/Nodatafound';
import { AuthContext } from 'contexts/AuthContext';
import attendanceService from 'ApiService/Teacher/Attendance';

const AttendancesReportData = ({ selectedClass }) => {
  const { state } = useContext(AuthContext);
  const [date, setDate] = useState('');
  const [attendanceList, setAttendanceList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showEditSheet, setShowEditSheet] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Available dates dropdown
  const [availableDates, setAvailableDates] = useState([]);

  // Helper to get string ID (in case it's an object)
  const getIdString = (id) => {
    if (typeof id === 'string') return id;
    if (typeof id === 'object' && id?._id) return id._id;
    return '';
  };

  // Fetch available attendance dates for dropdown
  const fetchMarkedDates = async () => {
    try {
      const courseId = getIdString(selectedClass.courseId);
      const batchId = getIdString(selectedClass.batchId);

      const res = await attendanceService.getMarkedAttendanceDates(
        courseId,
        batchId
      );
      if (res.data.success && res.data.dates?.length) {
        setAvailableDates(res.data.dates);
        setDate(''); // Don't auto-select, let user choose
      } else {
        setAvailableDates([]);
        setDate('');
        toast.error('No marked attendance dates found.');
      }
    } catch (err) {
      setAvailableDates([]);
      setDate('');
      toast.error('Error fetching marked dates.');
    }
  };

  // Fetch complete attendance (present + absent) for selected date
  const fetchCompleteAttendance = async (selectedDate) => {
    if (!selectedDate) return;
    try {
      setLoading(true);

      const courseId = getIdString(selectedClass.courseId);
      const batchId = getIdString(selectedClass.batchId);

      const res = await attendanceService.getCompleteAttendanceForDate(
        courseId,
        batchId,
        selectedDate
      );
      console.log('Fetched attendance data:', res.data);

      if (res.data.success) {
        setAttendanceList(res.data.data);
        setFilteredList(res.data.data);
      } else {
        setAttendanceList([]);
        setFilteredList([]);
        toast.error('No attendance data found for selected date.');
      }
    } catch (error) {
      setAttendanceList([]);
      setFilteredList([]);
      toast.error('Error fetching attendance data.');
    } finally {
      setLoading(false);
    }
  };

  // Handle date change from dropdown
  const handleDateChange = (selected) => {
    console.log(selected, 'selected value');
    if (!selected) return;
    setDate(selected.value);
    setShowEditSheet(false);
    setSearchTerm('');
    fetchCompleteAttendance(selected.value);
  };

  // Cycle attendance status for edit mode: Present -> Absent -> Unmarked -> Present
  const cycleStatus = (current) => {
    if (current === 'Present') return 'Absent';
    if (current === 'Absent') return 'Unmarked';
    return 'Present';
  };

  const handleCheckboxChange = (studentId) => {
    setAttendanceList((prev) =>
      prev.map((student) =>
        student._id === studentId
          ? { ...student, status: cycleStatus(student.status) }
          : student
      )
    );
    setFilteredList((prev) =>
      prev.map((student) =>
        student._id === studentId
          ? { ...student, status: cycleStatus(student.status) }
          : student
      )
    );
  };

  // Save updated attendance back to backend
  const saveAttendanceChanges = async () => {
    try {
      const courseId = getIdString(selectedClass.courseId);
      const batchId = getIdString(selectedClass.batchId);

      const absentStudents = attendanceList
        .filter((student) => student.status === 'Absent')
        .map((student) => student._id);

      const unmarkedStudents = attendanceList
        .filter((student) => student.status === 'Unmarked')
        .map((student) => student._id);

      // Sent explicitly so a Present mark is recorded rather than inferred — on
      // back-dated days an inferred Present cannot be told apart from "unmarked".
      const presentStudents = attendanceList
        .filter((student) => student.status === 'Present')
        .map((student) => student._id);

      const payload = {
        courseId,
        batchId,
        date,
        absentStudents,
        unmarkedStudents,
        presentStudents,
      };

      const res = await attendanceService.updateAttendance(payload);
      if (res.data.success) {
        toast.success('Attendance updated successfully.');
        setShowEditSheet(false);
        fetchCompleteAttendance(date);
      } else {
        toast.error('Failed to update attendance.');
      }
    } catch (error) {
      toast.error('Error updating attendance.');
    }
  };

  const handleSubmit = async () => {
    await saveAttendanceChanges();
    setIsModalOpen(false);
  };

  // Search/filter students
  useEffect(() => {
    if (!searchTerm) {
      setFilteredList(attendanceList);
    } else {
      const filtered = attendanceList.filter((student) =>
        student.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredList(filtered);
    }
  }, [searchTerm, attendanceList]);

  // Fetch available dates when selectedClass changes
  useEffect(() => {
    if (selectedClass) {
      fetchMarkedDates();
      setAttendanceList([]);
      setFilteredList([]);
      setShowEditSheet(false);
      setSearchTerm('');
    }
  }, [selectedClass]);

  return (
    <Card extra={'w-full sm:overflow-auto p-4'}>
      <header className="relative mt-10 flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          Attendance Report
        </div>
        {!showEditSheet && date && (
          <button
            onClick={() => setShowEditSheet(true)}
            className="h-10 w-40 rounded-xl bg-brand-500 text-lg text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            Edit Attendance
          </button>
        )}
      </header>

      <div className="mb-4 flex flex-col gap-4 md:flex-row md:items-end">
        <div className="w-60">
          <label className="mb-2 block text-sm font-bold text-gray-700 dark:text-white">
            Select Date:
          </label>
          <select
            value={date}
            onChange={(e) =>
              handleDateChange({ value: e.target.value, label: e.target.value })
            }
            className="
              w-full rounded-lg border border-gray-300 px-3 py-2 text-sm
              focus:outline-none focus:ring-2 focus:ring-brand-500
              dark:border-navy-600 dark:bg-navy-700 dark:text-white
            "
          >
            <option value="" disabled>
              Select date...
            </option>
            {availableDates.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>

        <div className="w-full md:w-64">
          <div className="relative">
            <input
              type="text"
              placeholder="Search by name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 pl-10 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 dark:border-navy-600 dark:bg-navy-700 dark:text-white"
            />
            <MdSearch className="absolute left-3 top-2.5 h-5 w-5 text-gray-500 dark:text-gray-400" />
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex h-64 items-center justify-center">
          <BallTriangle color="#5431ed" />
        </div>
      ) : showEditSheet ? (
        <div className="overflow-x-scroll xl:overflow-x-hidden">
          {filteredList.length ? (
            <>
              <div className="mb-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-gray-600 dark:text-gray-300">
                <span className="flex items-center gap-1">
                  <span className="inline-block h-4 w-4 rounded bg-green-100 text-center font-bold text-green-700 dark:bg-green-900/30 dark:text-green-400">
                    P
                  </span>
                  Present
                </span>
                <span className="flex items-center gap-1">
                  <span className="inline-block h-4 w-4 rounded bg-red-100 text-center font-bold text-red-700 dark:bg-red-900/30 dark:text-red-400">
                    A
                  </span>
                  Absent
                </span>
                <span className="flex items-center gap-1">
                  <span className="inline-block h-4 w-4 rounded border border-gray-300 text-center font-bold text-gray-400">
                    -
                  </span>
                  Not marked / Holiday (doesn't count in attendance %)
                </span>
              </div>
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-200 dark:border-white/10">
                    <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
                      SR.NO
                    </th>
                    <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
                      Attendance Mark
                    </th>
                    <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
                      Name
                    </th>
                    <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((student, idx) => (
                    <tr
                      key={student._id}
                      className="border-b border-gray-200 dark:border-white/10"
                    >
                      <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
                        {idx + 1}
                      </td>
                      <td className="px-[27px] py-[16px] text-center">
                        <div className="flex items-center justify-center">
                          <button
                            onClick={() => handleCheckboxChange(student._id)}
                            className={`h-7 w-7 rounded text-sm font-bold transition ${
                              student.status === 'Unmarked'
                                ? 'text-gray-400 hover:bg-gray-100 dark:hover:bg-navy-700'
                                : student.status === 'Present'
                                  ? 'bg-green-100 text-green-700 hover:bg-green-200 dark:bg-green-900/30 dark:text-green-400'
                                  : 'bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-900/30 dark:text-red-400'
                            }`}
                          >
                            {student.status === 'Unmarked'
                              ? '-'
                              : student.status === 'Present'
                                ? 'P'
                                : 'A'}
                          </button>
                        </div>
                      </td>
                      <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
                        {student.name}
                        {student.addedOn && (
                          <div className="text-[10px] font-normal text-gray-500">
                            Added:{' '}
                            {new Date(student.addedOn).toLocaleDateString('en-GB', {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric',
                            })}
                          </div>
                        )}
                      </td>
                      <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
                        {student.status}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="mt-4 flex justify-end gap-4">
                <button
                  onClick={() => {
                    setShowEditSheet(false);
                    fetchCompleteAttendance(date);
                  }}
                  className="rounded-xl bg-red-500 px-4 py-2 text-white hover:bg-red-600"
                >
                  Cancel
                </button>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="rounded-xl bg-green-500 px-4 py-2 text-white hover:bg-green-600"
                >
                  Save Changes
                </button>
              </div>
            </>
          ) : (
            <Nodatafound title="No attendance data found." />
          )}
        </div>
      ) : filteredList.length ? (
        <div className="overflow-x-scroll xl:overflow-x-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200 dark:border-white/10">
                <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
                  SR.NO
                </th>
                <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
                  Name
                </th>
                <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
                  Contact
                </th>
                <th className="px-[27px] py-[16px] text-center text-xs font-bold text-gray-600">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredList.map((student, idx) => (
                <tr
                  key={student._id}
                  className="border-b border-gray-200 dark:border-white/10"
                >
                  <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
                    {idx + 1}
                  </td>
                  <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
                    {student.name}
                    {student.addedOn && (
                      <div className="text-[10px] font-normal text-gray-500">
                        Added:{' '}
                        {new Date(student.addedOn).toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric',
                        })}
                      </div>
                    )}
                  </td>
                  <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
                    {student.contactNumber}
                  </td>
                  <td className="px-[27px] py-[16px] text-center font-medium text-navy-700 dark:text-white">
                    {student.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <Nodatafound
          title={
            searchTerm
              ? `No students found matching "${searchTerm}".`
              : 'No attendance data available.'
          }
        />
      )}

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleSubmit}
        title="Confirm Attendance Submission"
        message="Are you sure you want to submit the attendance for this class?"
        confirmText="Yes, Submit Attendance"
        cancelText="Cancel"
        icon="info"
      />
    </Card>
  );
};

export default AttendancesReportData;
